import React from 'react';
import NavMenu from './NavMenu';

const Header = () => (
  <header className="header">
    <h1 className="title">Math Magicians</h1>
    <NavMenu />
  </header>
);

export default Header;
